import { ReactComponent as IconCreatePost } from "assets/images/icons/pencil-square.svg";
import { ReactComponent as IconMegaphone } from "assets/images/icons/bxs-megaphone.svg";
import BackBar from "components/ui/BackBar/BackBar";
import ContentContainer from "layout/Content/ContentContainer";
import TitleWithIcon from "components/ui/TitleWithIcon/TitleWithIcon";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import ViewContextProvider from "features/view/context/ViewContext";
import { useHistory } from "react-router-dom";
import Sort from "features/view/components/Sort/Sort";
import ViewGroups from "features/groups/components/ViewGroups";
import GroupCreateUpdate from "features/groups/components/GroupCreateUpdate";

function GroupsPersonal() {
  const { showDialog } = useDialog();
  const history = useHistory();

  const sortOptions = [
    {
      id: 'created|DESC',
      value: 'Meest recent eerst',
    },
    {
      id: 'created|ASC',
      value: 'Minst recent eerst',
    },
    {
      id: 'title|ASC',
      value: 'Alfabetisch (oplopend)',
    },
    {
      id: 'title|DESC',
      value: 'Alfabetisch (aflopend)',
    },
  ];

  return (
    <>
      <BackBar path={ `/startpagina` } label={ 'Naar mijn startpagina' }/>

      <ContentContainer contentGridType={ 'wide' } contentPadding={ true } contentBackground={ true }>
        <div className={ 'content__header' }>
          <div>
            <TitleWithIcon title={ 'Mijn groepen' } hasBottomMargin={ true }>
              <IconMegaphone/>
            </TitleWithIcon>
            <p>
              Hier kunt u uw groepen bekijken, bewerken en verwijderen.
            </p>
          </div>

          <div className={ 'content__header-right' }>
            <Button variant={ 'secondary' } onClick={ () => showDialog(<GroupCreateUpdate
              onCompleted={ (bulletin) => history.push(bulletin.url) }/>) }>
              <IconCreatePost/>
              Nieuwe groep maken
            </Button>

            <Sort options={ sortOptions } variant={ 'transparent-primary' }/>
          </div>
        </div>

        <div className={ 'teasers-container--1col' }>
          <ViewContextProvider name={ 'my-group' }>
            <ViewGroups layoutPersonal={ true }/>
          </ViewContextProvider>
        </div>
      </ContentContainer>
    </>
  );
}

export default GroupsPersonal;
